import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { formatDateCustom } from './format-date-custom.js';
import isSameYear from 'date-fns/isSameYear';
import { formatTime } from './format-time.js';
import isSameDay from 'date-fns/isSameDay';
import isSameWeek from 'date-fns/isSameWeek';

/**
 * Format message date relative to now.
 *
 * Use this for UIs where a general timestamp is important, but precise specificity is not (e.g. last message sent in a list of messages).
 * As a best practice, show the absolute time on hover of the UI element (the HTML `title` attribute and the `time` element are your friends).
 *
 * Defaults:
 * - `format` = "short"
 */
function formatRelativeConversational(startDate, options) {
    let now = new Date();
    let convertedDate = new Date(startDate);
    // if setting the time zone, convert the time to the zoned time
    const ianaTimeZone = options === null || options === void 0 ? void 0 : options.ianaTimeZone;
    if (ianaTimeZone) {
        now = utcToZonedTime(now, ianaTimeZone);
        convertedDate = utcToZonedTime(convertedDate, ianaTimeZone);
    }
    const sharedFormatOptions = Object.assign({ includeDayOfWeek: false, includeMonthAndDay: true, includeYear: false, includeTime: false }, options);
    if (isSameDay(convertedDate, now)) {
        return formatTime(startDate, ianaTimeZone);
    }
    else if (isSameWeek(convertedDate, now)) {
        return formatDateCustom(startDate, Object.assign(Object.assign({}, sharedFormatOptions), { includeDayOfWeek: true, includeMonthAndDay: false }));
    }
    else if (isSameYear(convertedDate, now)) {
        return formatDateCustom(startDate, sharedFormatOptions);
    }
    else {
        return formatDateCustom(startDate, Object.assign(Object.assign({}, sharedFormatOptions), { includeYear: true }));
    }
}

export { formatRelativeConversational };
//# sourceMappingURL=format-relative-conversational.js.map
